"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSiteMapItem = void 0;
var _constants = require("../constants");
const trimPath = (pathToTrim)=>pathToTrim.replaceAll('/', '');
const arePathsEqual = (path1, path2)=>trimPath(path1) === trimPath(path2);
const getSiteMapItem = (path)=>{
    const keys = Object.keys(_constants.SiteMap);
    const child = keys.find((key)=>arePathsEqual(_constants.SiteMap[key].path, path));
    if (!child) {
        return null;
    }
    return _constants.SiteMap[child];
};
exports.getSiteMapItem = getSiteMapItem;
